import { createAction } from '@/utils/actions'
import * as toastActionTypes from './constants'

export const toastShow = createAction(toastActionTypes.TOAST_SHOW)
export const toastDismiss = createAction(toastActionTypes.TOAST_DISMISS)
